var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeperator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.44201 10.4369C1.37201 10.6282 1.26001 10.7705 1.10601 10.8639C0.95201 10.9619 0.795676 11.0109 0.63701 11.0109H9.54047e-06L4.14401 0.538862C4.20934 0.366196 4.30968 0.233196 4.44501 0.139863C4.58501 0.0465298 4.74368 -0.000136852 4.92101 -0.000136852H5.55801L1.44201 10.4369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeperator);
export default __webpack_public_path__ + "static/media/seperator.7c3970ead10fddb53a77856a0bf01170.svg";
export { ForwardRef as ReactComponent };